export default function SET_BROWSER_SUPPORT(
  store,
  { hasNativeDateInput = false }
) {
  store.browserSupport = {
    hasNativeDateInput,
  };
}
